module.exports = __webpack_public_path__ + "img/34_25.a082ef06.png";